import React, { useState } from "react";
import Faq from "./FAQ"; // Імпортуємо компонент Faq
import styles from "./FAQMini.module.scss";

interface FaqData {
  question: string;
  answer: string;
  description: string;
}

interface FaqBlockProps {
  faqData: FaqData[]; // Передаємо дані через пропс
}

const FaqBlock: React.FC<FaqBlockProps> = ({ faqData }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null); // Стан для збереження відкритого питання

  const handleToggle = (index: number) => {
    // Якщо клікнули на відкрите питання, закриваємо його, інакше відкриваємо нове
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container section">
      <div className={`sectionContainer sectionContainerWhite bigSection`}>
        <div className="sectionTitle sideP64">
          <div className={styles.faqMiniTitle}>
            <h2>Offene Stellen</h2>
            <p className="pageSubitle">
              Entdecken Sie spannende Karrieremöglichkeiten bei HIXA und werden
              Sie Teil unseres Teams!
            </p>
          </div>
        </div>
        <div className="sideP64 top30">
          {faqData.map((faq, index) => (
            <Faq
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index} // Передаємо чи питання відкрите
              onToggle={() => handleToggle(index)} // Передаємо функцію для відкриття/закриття
              description={faq.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqBlock;
